/* tslint:disable:max-line-length */
export const REDIRECT_NL = {
    '/gebruiksvoorwaarden': '/privacybeleid',
    '/groente/aubergine': '/producten/p/gegrilde-aubergine/03083681084863',
    '/groente/black-eyed-boon': '/',
    '/groente/bloemkool': '/producten/p/100-bloemkool-rijst/03083681101843',
    '/groente/boerenkool': '/producten/p/boerenkool/03083681017908',
    '/groente/borlottiboon': '/',
    '/groente/boterboon': '/producten/p/boterboontjes-zeer-fijn/03083680600835',
    '/groente/broccoli': '/producten/p/broccoliroosjes/03083680956598',
    '/groente/bruine-boon': '/producten/p/bruine-bonen/03083681012545',
    '/groente/cannelliniboon': '/producten/p/cannellini-bonen/03083680040259',
    '/groente/champignon': '/producten/p/parijse-champignons-gesneden/03083680010191',
    '/groente/courgette': '/',
    '/groente/doperwt': '/producten/p/doperwtjes-zeer-fijn/03083681011746',
    '/groente/edamame-bonen': '/producten/p/edamame-bonen/03083681065947',
    '/groente/gele-wortel': '/',
    '/groente/granen-zaden': '/producten/p/mix-van-granen-en-zaden-2-mini-packs/03083681097009',
    '/groente/groene-kidneyboon': '/producten/p/groene-kidneybonen/03083680600866',
    '/groente/haricots-verts': '/producten/p/haricots-verts-extra-fijn-gerangschikt/03083680597128',
    '/groente/kapucijner': '/producten/p/jonge-kapucijners/03083680019774',
    '/groente/kikkererwt': '/producten/p/kikkererwten/03083681012668',
    '/groente/limaboon': '/',
    '/groente/linzen': '/producten/p/linzen/03083681012644',
    '/groente/lotuswortel': '/',
    '/groente/mais': '/producten/p/crispy-mais/03083680597210',
    '/groente/oesterzwam': '/',
    '/groente/paprika': '/producten/p/gegrilde-paprika/03083681084849',
    '/groente/prei': '/',
    '/groente/quinoa-met-stoom-bereid': '/producten/p/quinoa-2-mini-packs/03083681085518',
    '/groente/reuzenboon': '/producten/p/reuzenbonen/03083681027280',
    '/groente/rode-biet': '/producten/p/rode-bietjes-schijfjes/03083680022699',
    '/groente/rode-kidneyboon': '/producten/p/rode-kidneybonen/03083681012583',
    '/groente/rode-kool': '/producten/p/rode-kool-met-appel/03083680023740',
    '/groente/snijboon': '/producten/p/snijboontjes/03083680956550',
    '/groente/spelt': '/producten/p/spelt-2-mini-packs/03083681097030',
    '/groente/sperzieboon': '/producten/p/franse-sperzieboontjes-zeer-fijn/03083680600828',
    '/groente/spinazie': '/producten/p/spinazie-gehakt/03083680001243',
    '/groente/spruit': '/producten/p/spruitjes/03083680956710',
    '/groente/sugar-snaps': '/producten/p/sugar-snaps/03083681026924',
    '/groente/tauge': '/',
    '/groente/tuinboon': '/producten/p/tuinboontjes/03083680956628',
    '/groente/ui': '/',
    '/groente/witte-boon': '/producten/p/witte-bonen-in-tomatensaus/03083680010726',
    '/groente/witte-kool': '/',
    '/groente/wortel': '/producten/p/worteltjes-extra-fijn/03083681012507',
    '/groente/zwarte-boon': '/producten/p/zwarte-bonen/03083681066470',
    '/groenten': '/producten',
    '/neem-contact-met-ons-op': '/',
    '/over-bonduelle': '/over-ons/nieuws',
    '/over-bonduelle/geschiedenis': '/over-ons/geschiedenis',
    '/over-bonduelle/jobs': 'https://www.bonduelle.com/en/no_cache/careers/job-offers.html',
    '/over-bonduelle/proces': '/',
    '/over-bonduelle/zout-en-suiker-reductie': '/',
    '/privacy-statement': '/privacybeleid',
    '/product/100-erwten-courgette-pasta-shape': '/producten/p/100-erwten-et-courgette/03083681081022',
    '/product/100-erwten-courgette-rice-shape': '/producten/p/100-erwten-et-courgette/03083681100402',
    '/product/100-kikkererwten-mais-pasta-shape': '/producten/p/100-kikkererwten-et-mais/03083681081039',
    '/product/100-linzen-wortel-pasta-shape': '/producten/p/100-linzen-et-wortel/03083681080971',
    '/product/100-linzen-wortel-rice-shape': '/producten/p/100-linzen-et-wortel/03083681100426',
    '/product/black-eyed-bonen': '/',
    '/product/bloemkoolrijst': '/producten/p/100-bloemkool-rijst/03083681101843',
    '/product/bloemkoolroosjes': '/producten/p/bloemkoolroosjes/03083680956680',
    '/product/boerenkool-pure': '/producten/p/boerenkool/03083681017908',
    '/product/boerensoepgroenten': '/producten/p/boerensoepgroenten/03083680009874',
    '/product/bonengerecht-indiaas': '/producten/p/bonengerecht-indiaas-met-groene-linzen-et-verrassende-groenten/03083681099409',
    '/product/bonengerecht-mediterraans': '/producten/p/bonengerecht-mediterraans-met-witte-boontjes-et-verrassende-groenten/03083681099430',
    '/product/bonengerecht-mexicaans': '/producten/p/bonengerecht-mexicaans-met-rode-kidneybonen-et-verrassende-groenten/03083681099348',
    '/product/bonengerecht-midden-oosters': '/producten/p/bonengerecht-midden-oosters-met-kikkererwten-et-verrassende-groenten/03083681099379',
    '/product/bonenmix-crispy-mais-rode-kidney-lima-black-eyed-bonen': '/producten/p/bonenmix-crispy-mais-rode-kidney-lima-et-black-eyed-bonen/03083681065916',
    '/product/bonenmix-edamame-kikkererwten-groene-kidneybonen': '/producten/p/bonenmix-edamame-kikkererwten-et-groene-kidneybonen/03083681065886',
    '/product/bonenmix-kikkererwten-witte-bonen-rode-kidney-lima-bonen': '/producten/p/bonenmix-kikkererwten-witte-bonen-rode-kidney-et-lima-bonen/03083681037388',
    '/product/bonenmix-vriesvers': '/',
    '/product/boterboontjes-zeer-fijn': '/producten/p/boterboontjes-zeer-fijn/03083680600835',
    '/product/broccolirijst': '/producten/p/100-broccoli-rijst/03083681101874',
    '/product/broccoliroosjes': '/producten/p/broccoliroosjes/03083680956598',
    '/product/bruine-bonen': '/producten/p/bruine-bonen/03083681012545',
    '/product/cannellini-bonen': '/producten/p/cannellini-bonen/03083681003901',
    '/product/chilibonen-pittige-saus': '/producten/p/chilibonen-in-saus/03083680479264',
    '/product/crispy-ma%C3%A9s': '/producten/p/crispy-mais/03083680597210',
    '/product/crispy-ma%C3%A9s-bio': '/producten/p/crispy-mais-bio/03083681002416',
    '/product/crispy-mais-mexicaanse-stijl': '/',
    '/product/crispy-mais-mini-packs': '/producten/p/crispy-mais-2-mini-packs/03083681068184',
    '/product/doperwtjes-extra-fijn-à-l%C3%A9tuv%C3%A9e': '/',
    '/product/doperwtjes-festini': '/producten/p/doperwtjes-festini/03083680538060',
    '/product/doperwtjes-worteltjes-zeer-fijn': '/producten/p/doperwtjes-et-worteltjes-zeer-fijn/03083681012767',
    '/product/doperwtjes-zeer-fijn-à-l%C3%A9tuv%C3%A9e': '/',
    '/product/edamame-bonen': '/producten/p/edamame-bonen/03083681065947',
    '/product/edamame-bonen-0': '/producten/p/edamame-bonen/03083681065947',
    '/product/edamame-bonen-mini-packs': '/producten/p/edamame-bonen-2-mini-packs/03083681079647',
    '/product/franse-sperzieboontjes-zeer-fijn': '/producten/p/franse-sperzieboontjes-zeer-fijn/03083680956758',
    '/product/franse-sperzieboontjes-zeer-fijn-0': '/producten/p/franse-sperzieboontjes-zeer-fijn/03083680600828',
    '/product/franse-sperzieboontjes-zeer-fijn-gerangschikt': '/producten/p/franse-sperzieboontjes-zeer-fijn-gerangschikt/03083680534796',
    '/product/gebroken-sperzieboontjes': '/producten/p/gebroken-sperzieboontjes-fijn/03083680002134',
    '/product/gegrilde-aubergine': '/producten/p/gegrilde-aubergine/03083681084863',
    '/product/gegrilde-courgette': '/producten/p/gegrilde-courgette/03083681084856',
    '/product/gegrilde-groenten': '/producten/p/gegrilde-aubergine-courgette-et-rode-paprika/03083681027099',
    '/product/gegrilde-mais': '/producten/p/gegrilde-mais/03083681084832',
    '/product/gegrilde-paprika': '/producten/p/gegrilde-paprika/03083681084849',
    '/product/gehakte-spinazie': '/producten/p/gehakte-spinazie/03083681004328',
    '/product/gehakte-spinazie-pure': '/producten/p/gehakte-spinazie/03083681004328',
    '/product/groene-kidneybonen': '/producten/p/groene-kidneybonen/03083680600866',
    '/product/haricots-verts-extra-fijn': '/producten/p/haricots-verts-extra-fijn/03083680956765',
    '/product/haricots-verts-extra-fijn-gerangschikt': '/producten/p/haricots-verts-extra-fijn-gerangschikt/03083680597234',
    '/product/haricots-verts-extra-fijn-gerangschikt-0': '/producten/p/haricots-verts-extra-fijn-gerangschikt/03083680014588',
    '/product/haricots-verts-miniatuur': '/producten/p/haricots-verts-miniatuur/03083680598453',
    '/product/indiase-curry': '/',
    '/product/jonge-kapucijners': '/producten/p/jonge-kapucijners/03083680019774',
    '/product/jonge-velderwtjes': '/producten/p/jonge-velderwtjes/03083681012682',
    '/product/jonge-velderwtjes-à-l%C3%A9tuv%C3%A9e': '/',
    '/product/jonge-velderwtjes-mini-packs': '/producten/p/jonge-velderwtjes-2-mini-packs/03083681072563',
    '/product/kervel': '/',
    '/product/kikkererwten': '/producten/p/kikkererwten/03083681012668',
    '/product/kikkererwten-bio': '/producten/p/kikkererwten-bio/03083681052848',
    '/product/kikkererwten-mini-packs': '/producten/p/kikkererwten-2-mini-packs/03083681068146',
    '/product/kikkererwten-vriesvers': '/',
    '/product/krielaardappeltjes': '/producten/p/krielaardappeltjes/03083680023733',
    '/product/linzen': '/producten/p/linzen/03083681012644',
    '/product/linzen-bio': '/producten/p/linzen-bio/03083681098389',
    '/product/linzen-vriesvers': '/',
    '/product/losse-spinazieblaadjes': '/producten/p/spinazie-blaadjes/03083681031928',
    '/product/macedoine-de-legumes': '/producten/p/macedoine-de-legumes/03083680600903',
    '/product/mais-fiesta': '/producten/p/mais-fiesta/03083680702935',
    '/product/ma%C3%A9skolven-pure': '/producten/p/maiskolven-twee-stuks/03083680045216',
    '/product/mais-olijven': '/producten/p/mais-et-olijven/03083681014044',
    '/product/mais-salsa': '/producten/p/mais-salsa/03083680702928',
    '/product/mediterraanse-ratatouille': '/',
    '/product/mexico-melange': '/producten/p/mexico-melange/03083680597159',
    '/product/mexico-m%C3%A9lange-pure': '/producten/p/mexico-melange/03083680956796',
    '/product/mix-van-granen-zaden-mini-packs': '/producten/p/mix-van-granen-en-zaden-2-mini-packs/03083681097009',
    '/product/parijse-champignons-gesneden': '/producten/p/parijse-champignons-gesneden/03083680010191',
    '/product/pruimen-op-siroop': '/producten/p/pruimen-op-siroop/03083680020411',
    '/product/quinoa-mini-packs': '/producten/p/quinoa-2-mini-packs/03083681085518',
    '/product/ratatouille-la-provencale': '/producten/p/ratatouille-a-la-provencale/03083681009767',
    '/product/reuzenbonen': '/producten/p/reuzenbonen/03083681027280',
    '/product/rode-bietjes-schijfjes': '/producten/p/rode-bietjes-schijfjes/03083680022699',
    '/product/rode-kidneybonen': '/producten/p/rode-kidneybonen/03083681066449',
    '/product/rode-kidneybonen-bio': '/producten/p/rode-kidneybonen-bio/03083681052831',
    '/product/rode-kidneybonen-mexicaanse-stijl': '/',
    '/product/rode-kidneybonen-mini-packs': '/producten/p/rode-kidneybonen-2-mini-packs/03083681068122',
    '/product/rode-kidneybonen-vriesvers': '/',
    '/product/rode-kool-met-appel': '/producten/p/rode-kool-met-appel/03083680023740',
    '/product/rode-kool-pure-met-appel': '/producten/p/rode-kool-met-appeltjes/03083681017878',
    '/product/snijboontjes': '/producten/p/snijboontjes/03083680956550',
    '/product/snijboontjes-met-witte-bonen': '/producten/p/snijboontjes-met-witte-bonen/03083680022712',
    '/product/snijboontjes-pure': '/producten/p/snijboontjes/03083680956550',
    '/product/spelt-mini-packs': '/producten/p/spelt-2-mini-packs/03083681097030',
    '/product/spinazie-la-creme-pure': '/producten/p/spinazie-a-la-creme/03083681004298',
    '/product/spruitjes': '/producten/p/spruitjes/03083680956710',
    '/product/spruitjes-0': '/producten/p/spruitjes/03083680022705',
    '/product/sugar-snaps-pure': '/producten/p/sugar-snaps/03083681026924',
    '/product/surinaamse-roti': '/',
    '/product/tuinboontjes': '/producten/p/tuinboontjes/03083680956628',
    '/product/tuinboontjes-pure': '/producten/p/tuinboontjes/03083680956628',
    '/product/tuinerwtjes-extra-fijn': '/producten/p/tuinerwtjes-extra-fijn/03083680956741',
    '/product/tuinerwtjes-worteltjes-zeer-fijn': '/producten/p/tuinerwtjes-en-worteltjes-zeer-fijn/03083680956697',
    '/product/witte-bonen-tomatensaus': '/producten/p/witte-bonen-in-tomatensaus/03083680010726',
    '/product/worteltjes-extra-fijn': '/producten/p/worteltjes-extra-fijn/03083681012507',
    '/product/zwarte-bonen': '/producten/p/zwarte-bonen/03083681066470',
    '/product/zwarte-bonen-mexicaanse-stijl': '/',
    '/product/zwarte-bonen-mini-packs': '/producten/p/zwarte-bonen-2-mini-packs/03083681068191',
    '/producten': '/producten',
    '/recept/aardappel-maistortilla-met-chorizo': '/recept',
    '/recept/avocado-salade-met-crispy-mais-en-grijze-garnalen': '/recept/r/avocado-salade-met-crispy-mais-en-grijze-garnalen/nlgp063',
    '/recept/aziatische-noedelsalade-met-edamame-bonen': '/recept',
    '/recept/balletjes-tomatensaus-met-kikkererwtjes': '/recept',
    '/recept/beans-club': '/recept',
    '/recept/big-bean': '/recept',
    '/recept/bitterballen-van-doperwtjes': '/recept',
    '/recept/black-eyed-bonenschotel-met-pindakaas-uit-ghana': '/recept',
    '/recept/bladerdeeghapje-met-ratatouille-en-mozzarella': '/recept',
    '/recept/bloemkoolcouscous-met-mais': '/recept/r/bloemkoolcouscous-met-mais/nlgp089',
    '/recept/bloemkoolrijst-en-chili-con-carne-met-gehaktballetjes-en-kruidenyoghurt': '/recept/r/bloemkoolrijst-en-chili-con-carne-met-gehaktballetjes-en-kruidenyoghurt/nlgp025',
    '/recept/bloemkoolrijst-met-thaise-kipcurry-en-sugar-snaps': '/recept/r/bloemkoolrijst-met-thaise-kipcurry-en-sugar-snaps/nlgp024',
    '/recept/boeuf-bourgignon-met-tuinerwten': '/recept',
    '/recept/bonensalade-met-feta': '/recept/r/bonensalade-met-feta/nlgp081',
    '/recept/bonensalade-met-witlof-appel-geitenkaas-en-limoen-yoghurtdressing': '/recept',
    '/recept/brochette-van-scampi-en-taboule-met-mais': '/recept',
    '/recept/broodje-falafel-met-zwarte-bonen-en-sesamsaus': '/recept',
    '/recept/broodpuddinkjes-met-zwarte-bonen': '/recept',
    '/recept/bruschetta-met-kidneybonen-en-gegrilde-paprika': '/recept/r/bruschetta-met-kidneybonen-en-gegrilde-paprika/nlgp047',
    '/recept/bruschetta-met-ratatouille': '/recept',
    '/recept/bruschetta-met-scampi-en-bonen-avocado-salsa': '/recept/r/bruschetta-met-scampi-en-bonen-avocado-salsa/nlgp067',
    '/recept/burrito-met-kip-en-rode-kidneybonen': '/recept',
    '/recept/caesar-salade-met-crispy-mais': '/recept/r/caesar-salade-met-crispy-mais/nlgp080',
    '/recept/caesarsalade-met-een-rode-twist': '/recept/r/caesarsalade-met-een-rode-twist/nlgp075',
    '/recept/cannelloni-met-spinazie-en-gehakt': '/recept',
    '/recept/caribbean-plaattaart-met-kidneybonen-mais-en-kaas': '/recept/r/caribbean-plaattaart-met-kidneybonen-mais-en-kaas/nlgp030',
    '/recept/chili-con-carne-met-rode-kidney-bonen': '/recept',
    '/recept/chili-sin-carne': '/recept/r/chili-sin-carne/nlgp045',
    '/recept/chinese-koolsoep-met-noedels-kip-en-sugar-snaps': '/recept',
    '/recept/citroen-maisrisotto-met-gegrilde-rozemarijnkip': '/recept',
    '/recept/couscous-met-kip-abrikozen-en-kikkererwten': '/recept',
    '/recept/couscoussalade-met-dadel-reuzenbonen-en-abrikozenyoghurt': '/recept',
    '/recept/couscoussalade-met-mais-linzen-en-citroendressing': '/recept',
    '/recept/cowboywrap': '/recept',
    '/recept/creoolse-gebakken-rijst-met-kip-en-rode-kidneybonen': '/recept',
    '/recept/crispy-mais-boterkoek-mathijs-vrieze': '/recept',
    '/recept/crostini-met-cannellini-en-ansjovis': '/recept',
    '/recept/crostini-met-rode-kidneybonen-salsa': '/recept',
    '/recept/doperwtdip-met-munt': '/recept',
    '/recept/doperwtensouffle': '/recept',
    '/recept/frisse-kikkererwtensalade-met-granaatappel': '/recept',
    '/recept/frisse-salade-met-gegrilde-courgette-mozzarella-en-citroendressing': '/recept/r/frisse-salade-met-gegrilde-courgette-mozzarella-en-citroendressing/nlgp032',
    '/recept/frisse-tartaar-van-groenten': '/recept/r/frisse-tartaar-van-groenten/nlgp056',
    '/recept/gegrilde-asperges-met-mais-black-eyed-bonen-en-croutons': '/recept/r/gegrilde-asperges-met-mais-black-eyed-bonen-en-croutons/nlgp070',
    '/recept/gegrilde-groenten-salade-met-crispy-mais': '/recept/r/gegrilde-groenten-salade-met-crispy-mais/nlgp064',
    '/recept/gegrilde-mais-tapas': '/recept/r/gegrilde-mais-tapas/nlgp059',
    '/recept/gegrilde-romeinse-sla-met-geroosterde-kikkererwten': '/recept/r/gegrilde-romeinse-sla-met-geroosterde-kikkererwten/nlgp072',
    '/recept/gehaktballetjes-met-doperwtjes-worteltjes': '/recept',
    '/recept/gemarineerde-gegrilde-groenten-met-rozemarijn-en-mini-mozzarella': '/recept/r/gemarineerde-gegrilde-groenten-met-rozemarijn-en-mini-mozzarella/nlgp037',
    '/recept/gentse-waterzooi-met-kikkererwten': '/recept',
    '/recept/geroosterde-pompoensoep-met-linzen': '/recept',
    '/recept/geroosterd-turks-brood-met-spinazie-salami-en-mozzarella': '/recept',
    '/recept/gestoofde-kip-met-doperwten-en-aardappel': '/recept',
    '/recept/gevulde-aubergine-met-borlottibonen-en-citroenyoghurt-1': '/recept',
    '/recept/gevulde-champignons-met-blauwe-kaas-en-cannellini-bonen': '/recept',
    '/recept/gevulde-puntpaprikas-met-zwarte-bonen': '/recept',
    '/recept/gevulde-scholrolletjes-met-cannellinibonen': '/recept',
    '/recept/gewokte-bloemkoolschotel-met-chipolataworstjes-naanbrood': '/recept',
    '/recept/gezonde-tonijnsalade-met-komkommer-en-rode-bonen': '/recept/r/gezonde-tonijnsalade-met-komkommer-en-rode-bonen/nlgp066',
    '/recept/gnocchi-met-paddenstoelen-kruidenolie-en-haricots-verts': '/recept',
    '/recept/griekse-moussaka-met-gegrilde-aubergine': '/recept/r/griekse-moussaka-met-gegrilde-aubergine/nlgp042',
    '/recept/griekse-pakketjes-met-tonijn-en-groene-kidneybonen': '/recept',
    '/recept/griekse-pastasalade-met-feta': '/recept/r/griekse-pastasalade-met-feta/nlgp013',
    '/recept/griekse-spinaziesalade-met-reuzenbonen-en-feta': '/recept',
    '/recept/grill-veggieburger': '/recept/r/grill-veggieburger/nlgp05',
    '/recept/groentenfrittata-met-black-eyed-bonen': '/recepten',
    '/recept/groentestoofpotje-met-paddenstoelen-en-noten': '/recepten',
    '/recept/gumbo-met-kip-garnalen-en-groene-kidneybonen': '/recepten',
    '/recept/hartige-groentetaart': '/recepten',
    '/recept/hartige-quiche-met-broccoli': '/recepten',
    '/recept/hollandse-vegetarische-couscous': '/recepten',
    '/recept/hummus': '/recepten',
    '/recept/indiase-garnalen-linzencurry': '/recepten',
    '/recept/indiase-linzencurry': '/recepten',
    '/recept/indiase-samosa': '/recepten',
    '/recept/italiaanse-bloemkoolrijstsalade': '/recept/r/italiaanse-bloemkoolrijstsalade/nlgp029',
    '/recept/italiaanse-pastasalade-met-mais-en-basilicumdressing': '/recepten',
    '/recept/italiaanse-soep-met-bruine-bonen-en-pancetta': '/recepten',
    '/recept/italiaanse-stoofschotel-met-rode-kidneybonen': '/recepten',
    '/recept/jet-kookt-met-daisy-edamamespread-op-toast': '/recept/r/jet-kookt-met-daisy-edamamespread-op-toast/nlgp053',
    '/recept/jet-kookt-met-daisy-salade-met-edamame-en-avocado': '/recept/r/jet-kookt-met-daisy-salade-met-edamame-en-avocado/nlgp052',
    '/recept/jet-kookt-met-kees-brownies-van-zwarte-bonen': '/recept/r/jet-kookt-met-kees-brownies-van-zwarte-bonen/nlgp054',
    '/recept/jet-kookt-met-kees-geroosterde-kikkererwten': '/recept/r/jet-kookt-met-kees-geroosterde-kikkererwten/nlgp055',
    '/recept/jonge-bladsla-met-appel': '/recepten',
    '/recept/kaas-tijmrisotto-met-tuinboontjes': '/recepten',
    '/recept/kabeljauw-met-warme-linzen-en-een-spinazieslaatje': '/recept/r/kabeljauw-met-warme-linzen-en-een-spinazieslaatje/nlgp074',
    '/recept/kabeljauw-met-zuurkool-en-reuzenbonen': '/recepten',
    '/recept/kerrierijst-met-doperwtjes-worteltjes': '/recepten',
    '/recept/kikkererwtencurry-met-kip-en-naanbrood': '/recepten',
    '/recept/kikkererwtenhamburger-met-ananassalsa': '/recepten',
    '/recept/kikkererwtenhummus-met-citroen': '/recepten',
    '/recept/kikkererwten-makreelsalade-met-tortillachips': '/recept/r/kikkererwtenhummus-met-citroen/nlgp092',
    '/recept/kikkererwtensalade-met-chorizo-paprika-en-sugarsnaps': '/recepten',
    '/recept/kikkererwtensalade-met-komijnekaas-en-munt': '/recepten',
    '/recept/kikkererwtensoep-met-knoflookroom': '/recepten',
    '/recept/kikkererwtentzatziki-met-gegrilde-kip': '/recept/r/kikkererwtentzatziki-met-gegrilde-kip/nlgp069',
    '/recept/kipburrito-met-kidneybonen-en-mais': '/recept/r/kipburrito-met-kidneybonen-en-mais/nlgp050',
    '/recept/kippenpotje-met-tuinboontjes-en-spek': '/recepten',
    '/recept/kippotje-met-kokos-en-cannellinibonen': '/recepten',
    '/recept/kipsalade-met-mais-kidneybonen-en-avocadodressing': '/recepten',
    '/recept/kipspiesjes-met-regenboogsalsa': '/recept/r/kipspiesjes-met-regenboogsalsa/nlgp073',
    '/recept/kleurrijke-tortilla-pizza': '/recept/r/kleurrijke-tortilla-pizza/nlgp076',
    '/recept/krieltjessalade-met-mais-en-kruidendressing': '/recepten',
    '/recept/krieltjessalade-met-rode-kidneybonen-en-kruidenmayo': '/recepten',
    '/recept/kruidige-couscous-met-dadels-noten-en-groene-kidneybonen': '/recepten',
    '/recept/krulsla-met-mango-en-avocado': '/recepten',
    '/recept/labneh-met-gegrilde-aubergine-zwarte-knoflook-tahinisaus': '/recepten',
    '/recept/lamstajine-met-kikkererwten': '/recepten',
    '/recept/lauwwarme-black-eyed-bonensalade': '/recepten',
    '/recept/lauwwarme-linzen-met-gegratineerde-geitenkaas': '/recepten',
    '/recept/linzencurry-met-doperwt-bloemkool-en-mangochutney': '/recepten',
    '/recept/linzensalade-met-bietjes-en-geitenkaas': '/recept/r/linzensalade-met-bietjes-en-geitenkaas/nlgp088',
    '/recept/linzensalade-met-mozzarella-en-tomaat': '/recept/r/linzensalade-met-mozzarella-en-tomaat/nlgp091',
    '/recept/linzensalade-met-paddenstoelen': '/recepten',
    '/recept/linzensalade-met-rucola-en-geitenkaas': '/recepten',
    '/recept/linzensoep-met-paprika': '/recepten',
    '/recept/luikse-salade-met-kikkererwten': '/recept/r/luikse-salade-met-kikkererwten/nlgp083',
    '/recept/maaltijdsoep-van-reuzenbonen': '/recepten',
    '/recept/maiskoekjes-met-tzatziki': '/recepten',
    '/recept/maismuffins': '/recepten',
    '/recept/maissoep-met-lente-uitjes-en-kipreepjes': '/recepten',
    '/recept/maki-cannellini': '/recepten',
    '/recept/marokkaanse-aardappelstoofpot-met-kurkuma-en-kidneybonen': '/recepten',
    '/recept/marokkaanse-kiptajine-met-gegrilde-courgette': '/recept/r/marokkaanse-kiptajine-met-gegrilde-courgette/nlgp040',
    '/recept/mediterraanse-pastasalade-met-crispy-mais': '/recepten',
    '/recept/mediterraans-vlees-en-vispotje': '/recepten',
    '/recept/mediterrane-bonensalade-met-gerookte-kip': '/recept/r/mediterrane-bonensalade-met-gerookte-kip/nlgp086',
    '/recept/mediterrane-ovenschotel-met-gegrilde-groenten-zalmfilet-en-dillepuree': '/recept/r/mediterrane-ovenschotel-met-gegrilde-groenten-zalmfilet-en-dillepuree/nlgp036',
    '/recept/mediterrane-salade-met-cannellinibonen': '/recepten',
    '/recept/mexicaanse-chilirijst-met-zwarte-bonen': '/recepten',
    '/recept/mexicaanse-tortilla-met-rode-kidneybonen': '/recepten',
    '/recept/mexicaanse-wraptaart': '/recept/r/mexicaanse-wraptaart/nlgp082',
    '/recept/minestronesoep-met-rode-kidneybonen-en-pancetta': '/recepten',
    '/recept/nasi-met-grote-garnalen': '/recepten',
    '/recept/nasi-van-broccolirijst-met-gehakt-en-champignons': '/recept/r/nasi-van-broccolirijst-met-gehakt-en-champignons/nlgp027',
    '/recept/noedels-met-pittig-gestoofde-rode-kidneybonen': '/recepten',
    '/recept/noedelsoep-met-varkensreepjes-en-groene-kidneybonen': '/recepten',
    '/recept/noodles-beans': '/recepten',
    '/recept/oosterse-garnalenschotel-met-black-eyed-bonen': '/recepten',
    '/recept/paella-met-kip-en-garnaaltjes': '/recepten',
    '/recept/pannenkoekentaart-met-zoete-kidneybonen': '/recepten',
    '/recept/parmentierschotel-met-linzen-en-ricotta': '/recepten',
    '/recept/pasta-met-bonen-spinazie-kip-en-pesto': '/recept/r/pasta-met-bonen-spinazie-kip-en-pesto/nlgp094',
    '/recept/pasta-met-gegrilde-groenten-spek-en-gormas': '/recept/r/pasta-met-gegrilde-groenten-spek-en-gormas/nlgp048',
    '/recept/pasta-peperonata-met-gegrilde-paprika': '/recept/r/pasta-peperonata-met-gegrilde-paprika/nlgp033',
    '/recept/pasta-pesto-met-sperziebonen-en-kipfilet': '/recept/r/pasta-pesto-met-sperziebonen-en-kipfilet/nlgp018',
    '/recept/pasta-ratatouille-met-gegrilde-kipfilet': '/recepten',
    '/recept/pastasalade-met-geroosterde-pompoen-pecorino-en-tijm': '/recepten',
    '/recept/pasta-salade-met-mais-appel-en-tuinkruidendressing': '/recept/r/pastasalade-met-geroosterde-pompoen-pecorino-en-tijm/nlgp014',
    '/recept/pastasalade-met-tonijn-cannellinibonen-en-salsa-verde': '/recepten',
    '/recept/penne-arrabiata-met-kabeljauwfilet': '/recept/r/penne-arrabiata-met-kabeljauwfilet/nlgp020',
    '/recept/penne-met-aubergine-ricotta-en-amandel': '/recept/r/penne-met-aubergine-ricotta-en-amandel/nlgp015',
    '/recept/penne-met-brie-bacon-en-doperwtjes': '/recepten',
    '/recept/penne-met-zwarte-bonen-saucijsjes-en-venkel': '/recepten',
    '/recept/pesto-salade-met-mais-en-bonen': '/recept/r/pesto-salade-met-mais-en-bonen/nlgp077',
    '/recept/pikante-rijstsalade': '/recepten',
    '/recept/pittige-kip-met-linzen-kokossaus': '/recepten',
    '/recept/pittige-linzen-met-hollandse-garnaaltjes': '/recepten',
    '/recept/pizza-bello-bono': '/recepten',
    '/recept/plaattaart-met-creme-fraiche-gegrilde-courgette-spek-en-ui': '/recept/r/plaattaart-met-creme-fraiche-gegrilde-courgette-spek-en-ui/nlgp041',
    '/recept/poke-bowl-met-broccolirijst-avocado-en-garnalen': '/recept/r/poke-bowl-met-broccolirijst-avocado-en-garnalen/nlgp026',
    '/recept/poke-bowl-met-edamame-bonen': '/recepten',
    '/recept/poke-bowl-met-peulvruchten-avocado-en-frisse-limoenvinaigrette': '/recept/r/poke-bowl-met-peulvruchten-avocado-en-frisse-limoenvinaigrette/nlgp046',
    '/recept/poke-bowl-met-quinoa-avocado-en-kikkererwten': '/recept/r/poke-bowl-met-quinoa-avocado-en-kikkererwten/nlgp022',
    '/recept/poke-bowl-met-sushirijst-zalm-en-edamame': '/recept/r/poke-bowl-met-sushirijst-zalm-en-edamame/nlgp021',
    '/recept/poke-bowl-met-tonijn-kidneybonen-en-mango': '/recept/r/poke-bowl-met-tonijn-kidneybonen-en-mango/nlgp023',
    '/recept/pompoensoep-met-zachte-geitenkaas-en-cannellini-bonen': '/recept/r/pompoensoep-met-zachte-geitenkaas-en-cannellini-bonen/nlgp093',
    '/recept/power-salad': '/recepten',
    '/recept/preistoofpotje-met-kruidenkaas-en-kikkererwten': '/recepten',
    '/recept/preitortilla-met-rode-kidneybonen-en-spekjes': '/recepten',
    '/recept/quiche-met-rode-kidneybonen-courgette': '/recepten',
    '/recept/quiche-met-spekjes-prei-en-rode-kidneybonen': '/recepten',
    '/recept/quiche-met-spinazie-geitenkaas-en-amandelen': '/recepten',
    '/recept/quiche-met-spinazie-rode-biet-geitenkaas-en-linzen': '/recept/r/quiche-met-spinazie-rode-biet-geitenkaas-en-linzen/nlgp068',
    '/recept/reuzenbonensalade-met-appel-en-tonijn': '/recepten',
    '/recept/reuzenbonen-uit-de-oven': '/recepten',
    '/recept/rigatoni-met-parmaham-courgette-en-olijven': '/recept/r/rigatoni-met-parmaham-courgette-en-olijven/nlgp019',
    '/recept/rijst-met-gewokte-pangasiusfilet-sugar-snaps-en-oestersaus': '/recept/r/rijst-met-gewokte-pangasiusfilet-sugar-snaps-en-oestersaus/nlgp017',
    '/recept/rijst-met-roergebakken-broccoli-kipfilet-en-hoisinsaus': '/recept/r/rijst-met-roergebakken-broccoli-kipfilet-en-hoisinsaus/nlgp016',
    '/recept/rijstsalade-met-kidneybonen-en-hummusdressing': '/recept/r/rijstsalade-met-kidneybonen-en-hummusdressing/nlgp012',
    '/recept/rijstsalade-met-mais-appel-en-kerriedressing': '/recepten',
    '/recept/risotto-met-gegrilde-paprika-gorgonzola-en-walnoten': '/recept/r/risotto-met-gegrilde-paprika-gorgonzola-en-walnoten/nlgp039',
    '/recept/rode-kidneybonensalade-met-gerookte-makreel': '/recept/r/rode-kidneybonensalade-met-gerookte-makreel/nlgp049',
    '/recept/roergebakken-broccolirijst-met-zalm-erwtjes-en-pesto': '/recept/r/roergebakken-broccolirijst-met-zalm-erwtjes-en-pesto/nlgp028',
    '/recept/romeinse-salade-met-tonijn': '/recepten',
    '/recept/romige-cannellinisoep-met-currygarnalen': '/recepten',
    '/recept/romige-risotto-met-groene-groenten-en-garnalen': '/recept/r/romige-risotto-met-groene-groenten-en-garnalen/nlgp011',
    '/recept/rostischotel-met-zwarte-bonen-en-een-pittige-kaasgratin': '/recepten',
    '/recept/roti-met-goedgevulde-dahl': '/recepten',
    '/recept/rucola-salade-met-gorgonzola': '/recepten',
    '/recept/runderreepjes-teriyaki-met-tauge-en-cannellinibonen': '/recepten',
    '/recept/runderstoof-met-rode-kool': '/recepten',
    '/recept/salade-met-gegrilde-paprika-tomaatjes-mozzarella-en-citroenolie': '/recept/r/salade-met-gegrilde-paprika-tomaatjes-mozzarella-en-citroenolie/nlgp038',
    '/recept/salade-met-mais-en-makreel': '/recepten',
    '/recept/salade-nicoise': '/recepten',
    '/recept/salsa-van-black-eyed-bonen': '/recepten',
    '/recept/siciliaanse-pizza-met-gegrilde-aubergine-en-ricotta': '/recept/r/siciliaanse-pizza-met-gegrilde-aubergine-en-ricotta/nlgp043',
    '/recept/snelle-bonencurry-met-cannellinibonen': '/recepten',
    '/recept/snelle-chili-con-carne': '/recepten',
    '/recept/spaanse-boerenstoofpot-met-kikkererwten': '/recepten',
    '/recept/spaghetti-bolognese-met-italiaanse-groentemix': '/recepten',
    '/recept/spaghetti-met-rode-pesto-en-reuzenbonen': '/recepten',
    '/recept/spinaziecurry-met-kaas-en-naanbrood': '/recepten',
    '/recept/spinazierisotto-met-noten': '/recepten',
    '/recept/spinaziesalade-met-kidneybonen-sinaasappel-en-feta': '/recept/r/spinaziesalade-met-kidneybonen-sinaasappel-en-feta/nlgp044',
    '/recept/spinaziesoep-met-hollandse-garnalen': '/recepten',
    '/recept/stamppotje-met-pesto-hamlapjes-met-jus-en-kruidige-sperziebonen': '/recepten',
    '/recept/stoofpotje-met-kikkererwten-en-spinazie': '/recepten',
    '/recept/stoofpotje-van-kikkererwten-met-kip': '/recept/r/stoofpotje-van-kikkererwten-met-kip/nlgp090',
    '/recept/stoofschotel-met-verse-worst-en-tuinbonen': '/recepten',
    '/recept/tagliatelle-met-spinazie-en-zalmsnippers': '/recepten',
    '/recept/tajine-met-kip-black-eyed-bonen-en-port': '/recepten',
    '/recept/tapenade-van-linzen': '/recepten',
    '/recept/tasty-sate': '/recepten',
    '/recept/thaise-viscurry-met-rode-kidneybonen-prei-en-koriander': '/recepten',
    '/recept/thaise-wok-met-tofu-en-reuzenbonen': '/recepten',
    '/recept/toast-met-gegrilde-groenten-hummus-rucola-en-parmezaanse-kaas': '/recept/r/toast-met-gegrilde-groenten-hummus-rucola-en-parmezaanse-kaas/nlgp034',
    '/recept/tortilla-met-kip-bonen-mais-en-een-frisse-appel-salsa': '/recept/r/tortilla-met-kip-bonen-mais-en-een-frisse-appel-salsa/nlgp078',
    '/recept/toscaanse-salade-met-rode-kidneybonen-en-parmaham': '/recepten',
    '/recept/tostadas-met-mais-kidneybonensalade': '/recepten',
    '/recept/tricolore-boontjessalade-met-avocadodressing': '/recept/r/tricolore-boontjessalade-met-avocadodressing/nlgp071',
    '/recept/turks-brood-met-reuzenbonen-tomatensaus': '/recepten',
    '/recept/turkse-gehaktspies-met-rode-kidneybonen-dressing': '/recepten',
    '/recept/varkenskoteletten-met-een-frisse-cannellini-bonensalade': '/recepten',
    '/recept/varkensrollade-uit-de-oven-met-rode-kidneybonen': '/recepten',
    '/recept/veggie-dippers': '/recepten',
    '/recept/veggie-eggie': '/recept/r/veggie-eggie/nlgp031',
    '/recept/veggie-tosti-deluxe': '/recepten',
    '/recept/vis-chili-met-chorizo': '/recepten',
    '/recept/viskoekjes-met-black-eyed-bonen-en-een-fris-komkommersausje': '/recepten',
    '/recept/vispastei-met-spinazie-en-tuinerwten': '/recepten',
    '/recept/watermeloensalade-met-bonen-feta-en-munt': '/recept/r/watermeloensalade-met-bonen-feta-en-munt/nlgp065',
    '/recept/witlofsalade-met-kikkererwten': '/recept/r/witlofsalade-met-kikkererwten/nlgp061',
    '/recept/witlofsoep-met-cannellinibonen': '/recepten',
    '/recept/wok-met-gelakte-kip-en-edamamebonen': '/recept/r/wok-met-gelakte-kip-en-edamamebonen/nlgp079',
    '/recept/worteltaartjes': '/recepten',
    '/recept/wrap-met-kip-mais-en-zelfgemaakte-guacamole': '/recepten',
    '/recept/zonnige-caesar-salade-met-crispy-mais': '/recepten',
    '/recept/zwarte-bonensalade-met-feta-gebakken-courgette': '/recepten',
    '/recept/zwarte-bonensalade-met-mais-linzen-en-mango': '/recepten',
    '/recept/zwarte-bonenstoof-met-kipdrumsticks': '/recepten',
    '/recepten': '/recepten',
    '/recepten/zoeken': '/',
    '/recepten/zoeken/categorie/gerecht/gevogelte': '/',
    '/recepten/zoeken/categorie/gerecht/pasta': '/',
    '/recepten/zoeken/categorie/gerecht/rijst': '/',
    '/recepten/zoeken/categorie/gerecht/vegetarisch': '/',
    '/recepten/zoeken/categorie/gerecht/vis': '/',
    '/recepten/zoeken/categorie/gerecht/vlees': '/',
    '/recepten/zoeken/categorie/keuken/aziatisch': '/',
    '/recepten/zoeken/categorie/keuken/fusion': '/',
    '/recepten/zoeken/categorie/keuken/mediterraan': '/',
    '/recepten/zoeken/categorie/keuken/midden-oosten': '/',
    '/recepten/zoeken/categorie/keuken/westers': '/',
    '/recepten/zoeken/categorie/keuken/zuid-amerikaans': '/',
    '/recepten/zoeken/categorie/menugang/bijgerecht': '/',
    '/recepten/zoeken/categorie/menugang/hoofdgerecht': '/',
    '/recepten/zoeken/categorie/menugang/lunch': '/',
    '/recepten/zoeken/categorie/menugang/nagerecht': '/',
    '/recepten/zoeken/categorie/menugang/soep': '/',
    '/recepten/zoeken/categorie/menugang/tussendoortje': '/',
    '/recepten/zoeken/categorie/menugang/voorgerecht': '/',
    '/recepten/zoeken/categorie/mood/best-of-beans': '/',
    '/recepten/zoeken/categorie/mood/best-of-mais': '/',
    '/recepten/zoeken/categorie/mood/eenhappers': '/',
    '/recepten/zoeken/categorie/mood/feestje': '/',
    '/recepten/zoeken/categorie/mood/snack-time': '/',
    '/recepten/zoeken/categorie/mood/spicy': '/',
    '/recepten/zoeken/categorie/mood/super-salads': '/',
    '/recepten/zoeken/categorie/mood/viva-la-vega': '/',
    '/recepten/zoeken/categorie/mood/werelds': '/',
    '/recepten/zoeken/groente/bloemkool/43%2B111%2B653': '/',
    '/recepten/zoeken/groente/broccoli/112%2B656': '/',
    '/recepten/zoeken/groente/courgette/93%2B350%2B466%2B579%2B673%2B678%2B679': '/',
    '/recepten/zoeken/groente/doperwt/43%2B59%2B61%2B62%2B63%2B86%2B87%2B118%2B124%2B125%2B678%2B679': '/',
    '/recepten/zoeken/groente/haricots-verts/43%2B70%2B74%2B86%2B103%2B113%2B114': '/',
    '/recepten/zoeken/groente/linzen/45%2B46%2B465%2B529%2B669%2B670%2B677%2B680': '/',
    '/recepten/zoeken/groente/rode-kool/47%2B106': '/',
    '/recepten/zoeken/groente/spinazie/72%2B105%2B108%2B109': '/',
    '/recepten/zoeken/groente/sugar-snaps/121%2B465': '/',
    '/recepten/zoeken/groente/tuinboon/102%2B123': '/',
    '/recepten/zoeken/groente/wortel/43%2B63%2B80%2B86%2B125%2B677%2B680': '/',
    '/recepten/zoeken/product/100-erwten-courgette-rice-shape/679': '/',
    '/recepten/zoeken/product/100-linzen-wortel-rice-shape/680': '/',
    '/recepten/zoeken/product/bloemkoolrijst/653': '/',
    '/recepten/zoeken/product/bloemkoolroosjes/111': '/',
    '/recepten/zoeken/product/broccolirijst/656': '/',
    '/recepten/zoeken/product/franse-sperzieboontjes-zeer-fijn/113': '/',
    '/recepten/zoeken/product/haricots-verts-extra-fijn/114': '/',
    '/recepten/zoeken/product/rode-kool-pure-met-appel/106': '/',
    '/recepten/zoeken/product/spinazie-la-creme-pure/105': '/',
    '/recepten/zoeken/product/sugar-snaps-pure/121': '/',
    '/recepten/zoeken/product/tuinboontjes-pure/123': '/',
    '/recepten/zoeken/product/tuinerwtjes-extra-fijn/124': '/',
    '/smultip/black-eye-bonen-met-tomatensalsa': '/recepten',
    '/smultip/black-eye-bonen-met-tomatensalsa/black-eyed-boon': '/recepten',
    '/smultip/black-eye-bonen-pita': '/recepten',
    '/smultip/black-eye-bonen-pita/black-eyed-boon': '/recepten',
    '/smultip/black-eye-bonen-rösti': '/recepten',
    '/smultip/black-eye-bonen-rösti/black-eyed-boon': '/recepten',
    '/smultip/bladerdeeghapje-met-champignons': '/recepten',
    '/smultip/bladerdeeghapje-met-champignons/champignon': '/recepten',
    '/smultip/bloemkool-met-kerrie': '/recepten',
    '/smultip/bloemkool-met-kerrie/bloemkool': '/recepten',
    '/smultip/boterboontjes-met-amandelen': '/recepten',
    '/smultip/boterboontjes-met-amandelen/boterboon': '/recepten',
    '/smultip/boterboontjes-op-chinese-wijze': '/recepten',
    '/smultip/boterboontjes-op-chinese-wijze/boterboon': '/recepten',
    '/smultip/broccoli-op-zn-italiaans': '/recepten',
    '/smultip/broccoli-op-zn-italiaans/broccoli': '/recepten',
    '/smultip/bruine-bonen-met-appeltjes': '/recepten',
    '/smultip/bruine-bonen-met-appeltjes/bruine-boon': '/recepten',
    '/smultip/bruine-bonen-met-kipreepjes': '/recepten',
    '/smultip/bruine-bonen-met-kipreepjes/bruine-boon': '/recepten',
    '/smultip/bruine-bonen-piccalilly': '/recepten',
    '/smultip/bruine-bonen-piccalilly/bruine-boon': '/recepten',
    '/smultip/champignonpakketje': '/recepten',
    '/smultip/chillbonen-pittige-saus': '/recepten',
    '/smultip/chillbonen-pittige-saus/rode-kidneyboon': '/recepten',
    '/smultip/crispy-ma%C3%A9s-pasta-met-kip': '/recepten',
    '/smultip/crispy-ma%C3%A9s-pasta-met-kip/mais': '/recepten',
    '/smultip/doperwtjes-met-sinaasappel': '/recepten',
    '/smultip/doperwtjes-met-sinaasappel/doperwt': '/recepten',
    '/smultip/doperwtjes-met-venkel': '/recepten',
    '/smultip/doperwtjes-met-venkel/doperwt': '/recepten',
    '/smultip/doperwtjes-op-marokkaanse-wijze': '/recepten',
    '/smultip/doperwtjes-op-marokkaanse-wijze/doperwt': '/recepten',
    '/smultip/doperwtjes-worteltjes-op-zn-grieks': '/recepten',
    '/smultip/frisse-couscoussalade': '/recepten',
    '/smultip/frisse-couscoussalade/groene-kidneyboon': '/recepten',
    '/smultip/frisse-kapucijnerssalade': '/recepten',
    '/smultip/frisse-kapucijnerssalade/kapucijner': '/recepten',
    '/smultip/frisse-kikkererwtensalade': '/recepten',
    '/smultip/frisse-kikkererwtensalade/kikkererwt': '/recepten',
    '/smultip/frisse-worteltjes-met-appel': '/recepten',
    '/smultip/frisse-worteltjes-met-appel/wortel': '/recepten',
    '/smultip/fruitige-spruitjes': '/recepten',
    '/smultip/fruitige-spruitjes/spruit': '/recepten',
    '/smultip/garnalen-met-cannellini-bonen': '/recepten',
    '/smultip/garnalen-met-cannellini-bonen/cannelliniboon': '/recepten',
    '/smultip/gebroken-sperzieboontjes-indonesia': '/recepten',
    '/smultip/gebroken-sperzieboontjes-indonesia/sperzieboon': '/recepten',
    '/smultip/gegratineerde-champignons': '/recepten',
    '/smultip/gegratineerde-champignons/champignon': '/recepten',
    '/smultip/gegrilde-groenten-met-kikkererwten': '/recepten',
    '/smultip/gegrilde-groenten-met-kikkererwten/kikkererwt': '/recepten',
    '/smultip/gevulde-saucijsjes': '/recepten',
    '/smultip/gevulde-saucijsjes/doperwt': '/recepten',
    '/smultip/gevulde-saucijsjes/haricots-verts': '/recepten',
    '/smultip/gevulde-saucijsjes/wortel': '/recepten',
    '/smultip/gezoete-boterboontjes': '/recepten',
    '/smultip/gezoete-boterboontjes/boterboon': '/recepten',
    '/smultip/italiaanse-mais-frittata': '/recepten',
    '/smultip/italiaanse-mais-frittata/mais': '/recepten',
    '/smultip/jonge-kapucijners-met-mierikswortel': '/recepten',
    '/smultip/jonge-kapucijners-met-mierikswortel/kapucijner': '/recepten',
    '/smultip/kapucijners-met-mosterdsaus': '/recepten',
    '/smultip/kapucijners-met-mosterdsaus/kapucijner': '/recepten',
    '/smultip/kikkererwten-egyptian-style': '/recepten',
    '/smultip/kikkererwten-egyptian-style/kikkererwt': '/recepten',
    '/smultip/kipstoofpotje': '/recepten',
    '/smultip/kipstoofpotje/groene-kidneyboon': '/recepten',
    '/smultip/knoflooklinzen-portsaus': '/recepten',
    '/smultip/knoflooklinzen-portsaus/linzen': '/recepten',
    '/smultip/krabsalade-met-ma%C3%A9s': '/recepten',
    '/smultip/krabsalade-met-ma%C3%A9s/mais': '/recepten',
    '/smultip/kruidige-cousous': '/recepten',
    '/smultip/kruidige-cousous/groene-kidneyboon': '/recepten',
    '/smultip/linzen-met-paddenstoelen': '/recepten',
    '/smultip/linzen-met-paddenstoelen/linzen': '/recepten',
    '/smultip/linzen-op-zn-marokkaans': '/recepten',
    '/smultip/linzen-op-zn-marokkaans/linzen': '/recepten',
    '/smultip/mac%C3%A9doine-met-champignons': '/recepten',
    '/smultip/mac%C3%A9doine-met-champignons/doperwt': '/recepten',
    '/smultip/mac%C3%A9doine-met-champignons/haricots-verts': '/recepten',
    '/smultip/mac%C3%A9doine-met-champignons/wortel': '/recepten',
    '/smultip/ma%C3%A9s-pannenkoekjes': '/recepten',
    '/smultip/ma%C3%A9s-pannenkoekjes/mais': '/recepten',
    '/smultip/mais-salsa': '/recepten',
    '/smultip/mais-salsa/mais': '/recepten',
    '/smultip/mexicaanse-taco’s': '/recepten',
    '/smultip/mexicaanse-taco’s/rode-kidneyboon': '/recepten',
    '/smultip/ovenschotel-met-rode-kidneybonen-en-champignons': '/recepten',
    '/smultip/ovenschotel-met-rode-kidneybonen-en-champignons/rode-kidneyboon': '/recepten',
    '/smultip/pasta-cannellini': '/recepten',
    '/smultip/pasta-cannellini/cannelliniboon': '/recepten',
    '/smultip/provencaalse-bonen': '/recepten',
    '/smultip/provencaalse-bonen/cannelliniboon': '/recepten',
    '/smultip/reuzenbonen-op-zn-afrikaans': '/recepten',
    '/smultip/reuzenbonen-op-zn-afrikaans/reuzenboon': '/recepten',
    '/smultip/reuzenbonen-tomatensaus': '/recepten',
    '/smultip/reuzenbonen-tomatensaus/reuzenboon': '/recepten',
    '/smultip/rijstsalade-met-zwarte-bonen': '/recepten',
    '/smultip/rijstsalade-met-zwarte-bonen/zwarte-boon': '/recepten',
    '/smultip/rode-bietjes-met-dijonmosterd': '/recepten',
    '/smultip/rode-bietjes-met-dijonmosterd/rode-biet': '/recepten',
    '/smultip/rode-bietjes-met-mandarijntjes': '/recepten',
    '/smultip/rode-bietjes-met-mandarijntjes/rode-biet': '/recepten',
    '/smultip/rode-kool-met-verse-appeltjes': '/recepten',
    '/smultip/rode-kool-met-verse-appeltjes/rode-kool': '/recepten',
    '/smultip/rode-kool-stoofpotje-met-rode-wijn': '/recepten',
    '/smultip/rode-kool-stoofpotje-met-rode-wijn/rode-kool': '/recepten',
    '/smultip/romige-boerenkool': '/recepten',
    '/smultip/romige-boerenkool/boerenkool': '/recepten',
    '/smultip/romige-champignonsoep-met-hoedje': '/recepten',
    '/smultip/romige-champignonsoep-met-hoedje/champignon': '/recepten',
    '/smultip/romige-spinazie': '/recepten',
    '/smultip/romige-spinazie/spinazie': '/recepten',
    '/smultip/salade-mac%C3%A9doine': '/recepten',
    '/smultip/salade-mac%C3%A9doine/doperwt': '/recepten',
    '/smultip/salade-mac%C3%A9doine/haricots-verts': '/recepten',
    '/smultip/salade-mac%C3%A9doine/wortel': '/recepten',
    '/smultip/salade-met-zwarte-bonen-en-sinaasappel': '/recepten',
    '/smultip/salade-met-zwarte-bonen-en-sinaasappel/zwarte-boon': '/recepten',
    '/smultip/sausje-van-rode-biet': '/recepten',
    '/smultip/sausje-van-rode-biet/rode-biet': '/recepten',
    '/smultip/snijbonen-met-grove-mosterd': '/recepten',
    '/smultip/snijbonen-met-grove-mosterd/snijboon': '/recepten',
    '/smultip/snijbonen-op-zn-hollands': '/recepten',
    '/smultip/snijbonen-op-zn-hollands/snijboon': '/recepten',
    '/smultip/sperzieboontjes-met-champignons': '/recepten',
    '/smultip/sperzieboontjes-met-champignons/sperzieboon': '/recepten',
    '/smultip/sperzieboontjes-op-franse-wijze': '/recepten',
    '/smultip/sperzieboontjes-op-franse-wijze/sperzieboon': '/recepten',
    '/smultip/spinazie-met-pijnboompitjes': '/recepten',
    '/smultip/spinazie-met-pijnboompitjes/spinazie': '/recepten',
    '/smultip/spinazie-met-zongedroogde-tomaatjes': '/recepten',
    '/smultip/spinazie-met-zongedroogde-tomaatjes/spinazie': '/recepten',
    '/smultip/spinazie-op-noorse-wijze': '/recepten',
    '/smultip/spinazie-op-noorse-wijze/spinazie': '/recepten',
    '/smultip/spruitjes-met-geitenkaas': '/recepten',
    '/smultip/spruitjes-met-geitenkaas/spruit': '/recepten',
    '/smultip/spruitjes-met-kerrie': '/recepten',
    '/smultip/spruitjes-met-kerrie/spruit': '/recepten',
    '/smultip/stamppotje-met-reuzenbonen': '/recepten',
    '/smultip/stamppotje-met-reuzenbonen/reuzenboon': '/recepten',
    '/smultip/stamppotje-met-snijbonen': '/recepten',
    '/smultip/stamppotje-met-snijbonen/snijboon': '/recepten',
    '/smultip/sugar-snaps-uit-azië': '/recepten',
    '/smultip/sugar-snaps-uit-azië/sugar-snaps': '/recepten',
    '/smultip/tapa-van-mais-en-chorizo': '/recepten',
    '/smultip/tapa-van-mais-en-chorizo/mais': '/recepten',
    '/smultip/tomaten-blauwe-kaassalade': '/recepten',
    '/smultip/tortillachips-met-chilibonen': '/recepten',
    '/smultip/tortillachips-met-chilibonen/rode-kidneyboon': '/recepten',
    '/smultip/tortilla-met-kip-en-salsa': '/recepten',
    '/smultip/tortilla-met-kip-en-salsa/rode-kidneyboon': '/recepten',
    '/smultip/tuinboontjes-frisse-yoghurtsaus': '/recepten',
    '/smultip/tuinboontjes-frisse-yoghurtsaus/tuinboon': '/recepten',
    '/smultip/tuinboontjes-lyonnaise': '/recepten',
    '/smultip/tuinboontjes-lyonnaise/tuinboon': '/recepten',
    '/smultip/tuinboontjes-met-pesto': '/recepten',
    '/smultip/tuinboontjes-met-pesto/tuinboon': '/recepten',
    '/smultip/winters-rode-kool-potje': '/recepten',
    '/smultip/winters-rode-kool-potje/rode-kool': '/recepten',
    '/smultip/worteltjes-met-amandel-en-kerrie': '/recepten',
    '/smultip/worteltjes-met-amandel-en-kerrie/wortel': '/recepten',
    '/smultip/worteltjes-met-dille': '/recepten',
    '/smultip/worteltjes-met-dille/wortel': '/recepten',
    '/smultip/zwarte-bonenchili': '/recepten',
    '/smultip/zwarte-bonenchili/zwarte-boon': '/recepten',
    '/user': '/',
    '/user/password': '/',
    '/user/register': '/',
    '/wereldse-groentegerechten': '/',
    '/zout-en-suiker-reductie': '/',
    '/over-ons/onze-geschiedenis': '/over-ons/geschiedenis',
    '/over-ons/onze-betrokkenheid': '/over-ons/mvo',
    '/over-ons/innovaties': '/over-ons/innovatie',
    '/onze-groenten': '/producten',
    '/producten/bonenpasta-rijst': '/producten',
    '/producten/groenterijst': '/producten/groentepasta-rijst'

};
